// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__24hGv","requiredAsterisk":"Info_requiredAsterisk__1uvu7"};